import styled, { css } from 'styled-components';

export const reset = css`
  margin: 0;
  padding: 0;
  text-indent: 0;
  list-style-type: none;
`;

export const StyledUl = styled.ul`
  ${reset}
`;
